export default __webpack_public_path__ + "static/media/settings.a14387b7.png";